import { Skeleton } from '@/shared/components/shadcn/skeleton';

export const CampaignOverviewSkeleton = () => {
  return (
    <div aria-hidden="true" className="space-y-6 p-6">
      <div className="grid w-full max-w-105 grid-cols-3 gap-2">
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} className="h-10" />
        ))}
      </div>

      <div className="grid gap-4 xl:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} className="h-50 space-y-4 p-5">
            <div className="h-4 w-24 rounded bg-zinc-300" />
            <div className="h-8 w-28 rounded bg-zinc-300" />
          </Skeleton>
        ))}
      </div>

      <div className="grid gap-6 xl:grid-cols-[1.3fr_0.9fr]">
        <Skeleton className="h-75" />
        <Skeleton className="h-75" />
      </div>
    </div>
  );
};
